<template>
  <b-row>
    <b-col cols="12" md="12" v-if="mode === 'edit'">
      <i class="far fa-check-circle mr-1" />
      <b v-text="$lang.profileLang.term_title" />:
      <span class="text-muted" v-text="termCaption" />
    </b-col>
    <b-col cols="12" md="12">
      <b-form-group
        :label="$lang.parvandeh"
        label-for="user"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.parvandeh"
          :rules="$v.parvandeh_selected.$params"
        />
        <selectAsync
          :options="parvandeh_options"
          v-model="$v.parvandeh_selected.$model"
          label="text"
          id="value"
          :asyncFind="getParvandehCombo"
          :isValid="
            $v.parvandeh_selected.$dirty ? !$v.parvandeh_selected.$error : null
          "
          :loading="parvandeh_loading"
          :disabled="mode === 'edit'"
          @input="getProvinceOptions"
        />
        <b-form-invalid-feedback
          :state="
            $v.parvandeh_selected.$dirty ? !$v.parvandeh_selected.$error : null
          "
        >
          <div v-if="!$v.parvandeh_selected.required">
            {{ $lang.error_required | replace($lang.parvandeh) }}
          </div>
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col cols="12" md="12">
      <b-alert :show="mode === 'edit'" variant="warning">
        <i class="fas fa-info-circle fa-lg mr-1" />
        <b v-html="hozehGhazayiNameAlert" />
      </b-alert>
      <b-form-group
        :label="$lang.hozeh_ghazayi_name"
        label-for="user"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.hozeh_ghazayi_name"
          :rules="$v.province_selected.$params"
        />
        <selectFind
          :options="province_options"
          v-model="$v.province_selected.$model"
          label="caption"
          id="id"
          :isValid="
            $v.province_selected.$dirty ? !$v.province_selected.$error : null
          "
          @input="getDetailOptions()"
          :loading="province_loading"
        />
        <b-form-invalid-feedback
          :state="
            $v.province_selected.$dirty ? !$v.province_selected.$error : null
          "
        >
          <div v-if="!$v.province_selected.required">
            {{ $lang.error_required | replace($lang.hozeh_ghazayi_name) }}
          </div>
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col cols="12" md="12">
      <b-form-group
        :label="$lang.last_hozeh_ghazayi_name"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.last_hozeh_ghazayi_name"
          :rules="$v.detail_selected.$params"
        />
        <selectFind
          :options="detail_options"
          v-model="$v.detail_selected.$model"
          :value="detail_selected"
          label="caption"
          id="id"
          :isValid="
            $v.detail_selected.$dirty ? !$v.detail_selected.$error : null
          "
          :loading="detail_loading"
        />

        <b-form-invalid-feedback
          :state="$v.detail_selected.$dirty ? !$v.detail_selected.$error : null"
        >
          <div v-if="!$v.detail_selected.required">
            {{ $lang.error_required | replace($lang.last_hozeh_ghazayi_name) }}
          </div>
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col cols="12" class="text-right mt-3">
      <b-button
        v-if="isAdmin(parentPermissions) && checkLoading"
        variant="success"
        @click="submit"
      >
        {{ $lang.submitButton }}
        <i class="fa fa-check" />
      </b-button>
      <b-button
        type="reset"
        class="ml-2"
        size="md"
        variant="danger"
        @click="close"
      >
        <i class="fa fa-ban"></i>
        {{ $lang.close }}
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import { isAdmin, generateApiUrl, renderEumOptions } from "@/shared/utils";

export default {
  name: "hozeh-ghazayi-form",
  props: {
    parentPermissions: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: null,
    },
    mode: {
      type: String,
      default: "add",
    },
  },
  validations: {
    parvandeh_selected: { required: requiredIf((vm) => vm.mode === "add") },
    province_selected: { required },
    detail_selected: {},
  },
  data() {
    return {
      parvandeh_options: [],
      parvandeh_selected: null,
      parvandeh_loading: false,
      province_options: [],
      province_selected: null,
      province_loading: false,
      detail_options: [],
      detail_selected: null,
      detail_loading: false,
      term: null,
    };
  },
  computed: {
    checkLoading() {
      return !this.parvandeh_loading && !this.province_loading;
    },
    hozehGhazayiNameAlert() {
      return "توجه : با تغییر حوزه نهایی انتخاب‌های قبلی حوزه ذیل این حوزه توسط کاربر پاک خواهد شد.";
    },
  },
  watch: {
    async item(value) {
      if (value) {
        await this.getProvinceOptions();
        await this.fetchData();
      }
    },
  },
  created() {
    // this.mode === "add" && this.getProvinceOptions();
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    generateApiUrl,
    renderEumOptions,
    close() {
      this.$emit("close");
    },
    async getParvandehCombo(query) {
      if (!query || query.length < 2) {
        return;
      }
      if (query.length > 2) {
        this.parvandeh_options = [];
      }
      try {
        this.parvandeh_loading = true;
        const url = generateApiUrl(["profile", "parvandeh_combo"]);
        const queryString = {
          search_txt: query,
          type: 1,
        };
        const response = await this.$httpService.get(url, queryString);
        const data = pathOr([], ["data", "data"], response);
        this.parvandeh_options = data.map((x) => {
          return {
            text: `${pathOr("", ["parvandeh_number"], x)} - ${pathOr(
              "",
              ["person", "name"],
              x
            )} ${pathOr("", ["person", "family"], x)} - ${pathOr(
              "",
              ["term", "caption"],
              x
            )}`,
            termId: pathOr("", ["term", "id"], x),
            value: pathOr("", ["parvandeh_code"], x),
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.parvandeh_loading = false;
      }
    },
    async getProvinceOptions() {
      try {
        this.province_options = [];
        this.province_loading = true;
        const termId = pathOr(null, ["termId"], this.parvandeh_selected);
        const url = generateApiUrl(
          ["profile", "hozeh_ghazayi_province_combo"],
          [],
          { term_id: termId }
        );
        const response = await this.$httpService.get(url);
        this.province_options = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.province_loading = false;
      }
    },
    async getDetailOptions() {
      try {
        this.detail_options = [];
        this.detail_loading = true;
        const termId = pathOr(null, ["termId"], this.parvandeh_selected);
        const provinceId = pathOr(null, ["id"], this.province_selected);
        const url = generateApiUrl(
          ["profile", "hozeh_ghazayi_detail_combo"],
          [],
          { hozeh_ghazayi_province_id: provinceId, term_id: termId }
        );
        const response = await this.$httpService.get(url);
        this.detail_options = [
          { id: null, caption: "هیچکدام" },
          ...pathOr([], ["data", "data"], response),
        ];
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.detail_loading = false;
      }
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      const parvandeh_code = pathOr(null, ["value"], this.parvandeh_selected);
      const payload = {
        parvandeh_code,
        hozeh_ghazayi_province_id: pathOr(null, ["id"], this.province_selected),
        hozeh_ghazayi_detail_id: pathOr(null, ["id"], this.detail_selected),
      };
      if (this.mode === "edit") {
        /* guidance: remove parvandeh code in payload when is edit mode */
        delete payload.parvandeh_code;
      }

      this.$emit("submit", payload, parvandeh_code);
    },
    async fetchData() {
      if (!this.item) return;
      this.termCaption = pathOr(
        null,
        ["parvandeh", "term", "caption"],
        this.item
      );
      this.parvandeh_selected = {
        text: `${pathOr(
          "",
          ["parvandeh", "parvandeh_number"],
          this.item
        )} - ${pathOr("", ["person", "name"], this.item)} ${pathOr(
          "",
          ["person", "family"],
          this.item
        )} - ${pathOr("", ["person", "national_code"], this.item)}`,
        value: pathOr("", ["parvandeh", "code"], this.item),
      };
      this.province_selected = this.province_options.find(
        (x) =>
          x.id === pathOr(null, ["hozeh_ghazayi_province", "id"], this.item)
      );
      await this.getDetailOptions();
      this.detail_selected = this.detail_options.find(
        (x) => x.id === pathOr(null, ["hozeh_ghazayi_detail", "id"], this.item)
      );
    },
  },
};
</script>
